$(document).ready(function () {
  var $starSliderContainer = $('.star-slider-container');
  if ($starSliderContainer.length) {
    var $slider = $starSliderContainer.find('.slider-row').slick({
      draggable: true,
      lazyLoad: 'progressive',
      infinite: false,
      speed: 800,
      swipe: true,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            autoplay: false,
          }
        }
      ]
    });

    $(window).on('resize', function() {
      $slider.slick('resize');
    });

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var elSlide = $(slick.$slides[nextSlide]);
      var bgcolorholder = elSlide.data('bgcolorholder');
      $starSliderContainer.attr('data-bg-color', bgcolorholder);
    });
  }
});